import Vue from 'vue';
import App from './App.vue';
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';

Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [],
    // Add query string to the router
    parseQuery: function(query) {
        return {
            lang: query.lang
        };
    }
});

new Vue({
    router,
    render: (h) => h(App)
}).$mount('#app');
